import React, { Fragment } from "react";

const QueryCleaner = ({ Owl }) => {
    [Owl.queryParams, Owl.setQueryParams] = React.useState({});
    console.debug("QueryCleaner RD");

    const toDelete = React.useMemo(() => {
        return Object.entries(Owl.queryParams).filter(([_, value]) => value.clear);
    }, [Owl.queryParams]);

    return toDelete.length > 0 ? (
        <div className="owl-query-cleaner">
            {toDelete.map(([_, _queryProp]) => (
                <button
                    key={_}
                    onClick={() => {
                        delete Owl.queryParams[_];
                        Owl.setQueryParams({ ...Owl.queryParams });
                        _queryProp.clear();
                        Owl.search();
                    }}
                    className="owl-button p-1 px-2">
                    <span>{`X- ${_queryProp.title} : ${_queryProp.titleValue || _queryProp.value}`}</span>
                </button>
            ))}
        </div>
    ) : (
        <Fragment />
    );
};

export default QueryCleaner;
